module.exports = {
  NODE_ENV: '"production"',
  API_URL: '"https://investigationapi.xbees.in/api/"',
  AWS_BUCKET: '"xbees"',
  FORGOT_PASSWORD: '"http://userauthentication.xbees.in/#/forgotpassword"',
  Image_URL: '"https://xbees.s3.amazonaws.com/"',
  Dispute_Bucket : '"investigationimages"'

}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 237
// module chunks = 1